import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const BackpackIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 10.2a4.2 4.2 0 0 1 4.2-4.2h3.6A4.2 4.2 0 0 1 18 10.2v8.1a1.7 1.7 0 0 1-1.7 1.7H7.7A1.7 1.7 0 0 1 6 18.3z" />
    <path d="M9.7 6V4.9a1.6 1.6 0 0 1 1.6-1.6h1.4a1.6 1.6 0 0 1 1.6 1.6V6" />
    <path d="M9.2 12.9h5.6v3.4H9.2z" />
  </svg>
)
